import { BasicModel } from "@goodgamestudios/core";
import { TextFieldHelper } from "@goodgamestudios/core";
import { MathBase } from "@goodgamestudios/core";
import { BasicStandardYesNoDialogProperties } from "@goodgamestudios/core";

import { getQualifiedClassName } from "@goodgamestudios/createjs-utilities";
import { Loader } from "@goodgamestudios/createjs-utilities";
import { URLRequest } from "@goodgamestudios/createjs-utilities";
import { int } from "@goodgamestudios/math-utilities";
import { Back, Sine } from "gsap";
import { TweenMaxGroup } from "../helper/TweenMaxGroup";
import { SFConstants } from "../../constants/SFConstants";
import { Balancing } from "../../constants/shared/Balancing";
import { Poker2AvatarEvent } from "../../event/Poker2AvatarEvent";
import { Poker2BuddyEvent } from "../../event/Poker2BuddyEvent";
import { Poker2GiveChipsEvent } from "../../event/Poker2GiveChipsEvent";
import { Poker2UserEvent } from "../../event/Poker2UserEvent";
import { BuddyVO } from "../../gamevo/BuddyVO";
import { Poker2Model } from "../../model/Poker2Model";
import { Poker2GiveChipsConfigDialogProperties } from "../dialogs/giveChipsConfig/Poker2GiveChipsConfigDialogProperties";
import { PokerTextHelper } from "../helper/PokerTextHelper";
import { Poker2Panel } from "./Poker2Panel";

import DisplayObject = createjs.DisplayObject;
import MovieClip = createjs.MovieClip;
import Container = createjs.Container;
import Event = createjs.Event;
import IOErrorEvent = createjs.IOErrorEvent;
import MouseEvent = createjs.MouseEvent;
import SecurityErrorEvent = createjs.SecurityErrorEvent;
import Rectangle = createjs.Rectangle;

export class Poker2FriendsPanel extends Poker2Panel {
    public static NAME: string = "Poker2FriendsPanel";

    private static NOPIC_PATTERN: RegExp;
    private static AVATAR_SCALE_FACTOR: number = 0.5;
    private static CARD_INFO_START_Y: number = 0;
    private static CARD_INFO_END_Y: number;

    private CITEM_HEIGHT: number = 55;
    private ITEMS_PER_PAGE: number = 8;
    private currentCard: number = 0;
    private ownCardIndex: number = 0;
    private friendList: any[];
    private selectedCard: Library.PokerFriendsPanel.FriendCard;
    private _friendCardGotChips: Library.PokerFriendsPanel.FriendCard;

    constructor(disp: DisplayObject) {
        CONSTRUCTOR_HACK;
        super(disp);
    }

    protected init(): void {
        super.init();
        this.currentCard = 0;
        this.friendList = [];
        this.friendsPanel.btn_addfriend.maxWidth = 80;
        //			friendsPanel.btn_addfriend.enableButton = !Poker2Model.userData.isGuest();
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.friendsPanel.btn_addfriend.txt_label, Poker2Model.languageData.getTextById("buddylist_addfriend"), 2);
        this.friendsPanel.btn_addfriend.visible = this.env.invitefriends;
        this.friendsPanel.btn_addfriend.bg.doCache();
        this.controller.addEventListener("changebuddydata", this.bindFunction(this.onChangeBuddyData));
        this.controller.addEventListener("avatarChanged", this.bindFunction(this.onChangeAvatarData));
        this.controller.addEventListener("changeUserCurrency", this.bindFunction(this.onChangeAvatarData));
        this.controller.addEventListener("avatarClothesChanged", this.bindFunction(this.onChangeAvatarData));
        this.controller.addEventListener("changeonlinestate", this.bindFunction(this.onChangeOnlineState));
        this.controller.addEventListener("chipsSent", this.bindFunction(this.onChipsSent));
        this.friendsPanel.bg.doCache();
        for (var i: number = 0; i < this.ITEMS_PER_PAGE; i++) {
            var card: Library.PokerFriendsPanel.FriendCard = this.friendsPanel["friendCard" + i] as Library.PokerFriendsPanel.FriendCard;
            card.btn_addfriend.bg.doCache();
        }
    }

    public show(): void {
        super.show();
        this.friendList = Poker2Model.buddyList.friendList;

        for (var i: number = 0; i < this.ITEMS_PER_PAGE; i++) {
            var card: Library.PokerFriendsPanel.FriendCard = this.friendsPanel["friendCard" + i] as Library.PokerFriendsPanel.FriendCard;
            card.addEventListener(MouseEvent.ROLL_OVER, this.bindFunction(this.onFriendCardRollOver));
            card.addEventListener(MouseEvent.ROLL_OUT, this.bindFunction(this.onFriendCardRollOut));
        }

        this.reposition();
    }

    private onChangeAvatarData(event: Event): void {
        this.friendList = Poker2Model.buddyList.friendList;
        var buddyData: BuddyVO;

        for (var i: number = 0; i < this.friendList.length; i++) {
            var buddyVO: BuddyVO = this.friendList[i] as BuddyVO;

            if (buddyVO.playerId == Poker2Model.userData.playerID) {
                buddyData = buddyVO;
                break;
            }
        }

        if (this.ownCardIndex >= 0 && buddyData) {
            // nur den avatar der eigene Karte updaten
            var cItem: Library.PokerFriendsPanel.FriendCard = this.friendsPanel["friendCard" + this.ownCardIndex] as Library.PokerFriendsPanel.FriendCard;
            cItem.uncache();
            this.fillBuddyItem(cItem, buddyData, false);
        }
    }

    private onChangeBuddyData(event: Poker2BuddyEvent): void {
        this.friendList = Poker2Model.buddyList.friendList;
        this.fillItems();
    }

    /**
     * Repositionierung anhand des eigenen Avatars
     * Der eigene Avatar ist möglichst mittig
     */
    private reposition(): void {
        var myCardPos: number = 0;

        for (var i: number = 0; i < this.friendList.length; i++) {
            var buddyVO: BuddyVO = this.friendList[i] as BuddyVO;

            if (buddyVO.playerId == Poker2Model.userData.playerID)
                myCardPos = i;
        }

        if (this.friendList.length <= this.ITEMS_PER_PAGE || myCardPos < this.ITEMS_PER_PAGE / 2)
            this.currentCard = 0;
        else if (myCardPos > (this.friendList.length - this.ITEMS_PER_PAGE / 2))
            this.currentCard = int(this.friendList.length - this.ITEMS_PER_PAGE);
        else
            this.currentCard = myCardPos - this.ITEMS_PER_PAGE / 2;

        this.fillItems();
    }

    public destroy(): void {
        super.destroy();
        this.controller.removeEventListener("changebuddydata", this.bindFunction(this.onChangeBuddyData));
        this.controller.removeEventListener("avatarClothesChanged", this.bindFunction(this.onChangeAvatarData));
        this.controller.removeEventListener("avatarChanged", this.bindFunction(this.onChangeAvatarData));
        this.controller.removeEventListener("changeUserCurrency", this.bindFunction(this.onChangeAvatarData));
        this.controller.removeEventListener("changeonlinestate", this.bindFunction(this.onChangeOnlineState));
        this.controller.removeEventListener("chipsSent", this.bindFunction(this.onChipsSent));

        for (var i: number = 0; i < this.ITEMS_PER_PAGE; i++) {
            var card: Library.PokerFriendsPanel.FriendCard = this.friendsPanel["friendCard" + i] as Library.PokerFriendsPanel.FriendCard;
            card.removeEventListener(MouseEvent.ROLL_OVER, this.bindFunction(this.onFriendCardRollOver));
            card.removeEventListener(MouseEvent.ROLL_OUT, this.bindFunction(this.onFriendCardRollOut));
        }
    }

    private onFriendCardRollOver(event: MouseEvent): void {
        var card: Library.PokerFriendsPanel.FriendCard = event.currentTarget;

        var playerID = Poker2Model.userData.playerID;
        var isNotPlayer = card.buddyData ? card.buddyData.playerId != playerID : false;
        if (card.buddyData && card.mc_cardinfo.y == Poker2FriendsPanel.CARD_INFO_START_Y && isNotPlayer && !card.mc_cardinfo.isOpening) {
            card.mc_cardinfo.isOpening = true;
            var openCard: TweenMaxGroup = new TweenMaxGroup();
            openCard.to(card.mc_cardinfo, .2, { y: Poker2FriendsPanel.CARD_INFO_END_Y, ease: Sine.easeOut, onComplete: this.bindFunction(this.onCompleteTweenAnim), onCompleteParams: [openCard, card.mc_cardinfo] });
            openCard.play();
        }

        this.layoutManager.gameStage.tickEnabled = false;
        this.layoutManager.onMenu = true;
    }

    private onFriendCardRollOut(event: MouseEvent): void {
        var card: Library.PokerFriendsPanel.FriendCard = event.currentTarget;

        if (card.mc_cardinfo.y == Poker2FriendsPanel.CARD_INFO_END_Y && !card.mc_cardinfo.isClosing) {
            card.mc_cardinfo.isClosing = true;
            var closeCard: TweenMaxGroup = new TweenMaxGroup();
            closeCard.to(card.mc_cardinfo, .3, { y: Poker2FriendsPanel.CARD_INFO_START_Y, ease: Back.easeOut, onComplete: this.bindFunction(this.onCompleteTweenAnim), onCompleteParams: [closeCard, card.mc_cardinfo] });
            closeCard.play();
        }
        this.layoutManager.gameStage.tickEnabled = true;
        this.layoutManager.onMenu = false;
    }

    private onCompleteTweenAnim(tweenGroup: TweenMaxGroup, target: MovieClip): void {
        if (target.isOpening) {
            target.isOpening = false;

            target.transitionState = "isOpened";
        }
        if (target.isClosing) {
            target.isClosing = false;

            target.transitionState = "isClosed";
        }

        tweenGroup.destroy();
        tweenGroup = null;
    }

    private deselectAllFriendCards(): void {
        for (var i: number = 0; i < this.ITEMS_PER_PAGE; i++) {
            // zuklappen
            var card: Library.PokerFriendsPanel.FriendCard = this.friendsPanel["friendCard" + i] as Library.PokerFriendsPanel.FriendCard;

            if (card.mc_cardinfo.isOpening || card.mc_cardinfo.transitionState == "isOpened") {
                card.mc_cardinfo.isClosing = true;
                var tweenCard: TweenMaxGroup = new TweenMaxGroup();
                tweenCard.to(card.mc_cardinfo, .3, { y: Poker2FriendsPanel.CARD_INFO_START_Y, ease: Back.easeOut, delay: .2, onComplete: this.bindFunction(this.onCompleteTweenAnim), onCompleteParams: [tweenCard, card.mc_cardinfo] });
                tweenCard.play();
            }
        }
    }

    protected onRollOut(event: MouseEvent): void {
        super.onRollOut(event);
        this.deselectAllFriendCards();
        this.layoutManager.gameStage.tickEnabled = true;
        this.layoutManager.onMenu = false;
    }

    protected onRollOver(event: MouseEvent): void {
        super.onRollOver(event);
        this.layoutManager.gameStage.tickEnabled = false;
        this.layoutManager.onMenu = true;
    }

    protected onClick(event: MouseEvent): void {
        if (event.target instanceof BasicButton && !event.target.enabled)
            return;

        if (this.isLocked)
            return;
        super.onClick(event);

        switch (event.target) {
            case this.friendsPanel.btn_addfriend:
                this.addFriend();
                break;
            case this.friendsPanel.btn_right_line:
                this.currentCard = int(MathBase.max(0, this.currentCard - this.ITEMS_PER_PAGE));
                this.fillItems();
                break;
            case this.friendsPanel.btn_left_line:
                this.currentCard = int(MathBase.min(this.friendList.length, this.currentCard + this.ITEMS_PER_PAGE));
                this.fillItems();
                break;
            case this.friendsPanel.btn_right_card:
                this.currentCard = int(MathBase.max(0, this.currentCard - 1));
                this.fillItems();
                break;
            case this.friendsPanel.btn_left_card:
                this.currentCard = int(MathBase.min(this.friendList.length, this.currentCard + 1));
                this.fillItems();
                break;
            case this.friendsPanel.btn_right_end:
                this.currentCard = 0;
                this.fillItems();
                break;
            case this.friendsPanel.btn_left_end:
                this.currentCard = int(MathBase.max(0, this.friendList.length - this.ITEMS_PER_PAGE));
                this.fillItems();
                break;
            default:
                if (instanceOfClass(event.target, "Btn_Addfriend"))
                    this.addFriend();
                if (instanceOfClass(event.target, "Btn_BuddyList_Statistic"))
                    this.onShowUserInfo(event.target.parent.parent as Library.PokerFriendsPanel.FriendCard);
                if (instanceOfClass(event.target, "Btn_BuddyList_Join"))
                    this.onJoinUser(event.target.parent.parent as Library.PokerFriendsPanel.FriendCard);
                if (instanceOfClass(event.target, "Btn_BuddyList_Remove"))
                    this.onRemoveFriend(event.target.parent.parent as Library.PokerFriendsPanel.FriendCard);
                if (instanceOfClass(event.target, "Btn_BuddyList_Chips"))
                    this.onSpendChips(event.target.parent.parent as Library.PokerFriendsPanel.FriendCard);
                break;
        }
    }

    private addFriend(): void {
        if (this.env.loginIsKeyBased) {
            Poker2Model.socialData.inviteFriends();
            this.layoutManager.revertFullscreen();
        }
        else if (!Poker2Model.userData.isGuest())
            this.layoutManager.showDialog("Poker2InviteFriendDialog");
        else if (Poker2Model.userData.isGuest())
            this.layoutManager.showDialog("Poker2GuestInviteFriendDialog");
    }

    private onShowUserInfo(card: Library.PokerFriendsPanel.FriendCard): void {
        var paramObject: any = { id: card.buddyData.playerId };
        BasicModel.smartfoxClient.sendMessage("gpp", [JSON.stringify(paramObject)]);
    }

    private onJoinUser(card: Library.PokerFriendsPanel.FriendCard): void {
        var paramObject: any = { pId: (card.buddyData as BuddyVO).playerId };
        BasicModel.smartfoxClient.sendMessage("cjf", [JSON.stringify(paramObject)]);
    }

    private onRemoveFriend(card: Library.PokerFriendsPanel.FriendCard): void {
        this.selectedCard = card;
        this.layoutManager.showDialog(Poker2StandardYesNoDialog.NAME, new BasicStandardYesNoDialogProperties(Poker2Model.languageData.getTextById("dialog_profilecard_removeBuddy"), Poker2Model.languageData.getTextById("dialog_removeBuddy_copy", [card.buddyData.playerName]), this.bindFunction(this.removeFriend)));
    }

    private removeFriend(params: any[]): void {
        if (this.selectedCard) {
            var paramObject: any = { status: 3, offerPID: Poker2Model.userData.playerID, receivePID: this.selectedCard.buddyData.playerId };
            BasicModel.smartfoxClient.sendMessage("big", [JSON.stringify(paramObject)]);
        }
    }

    private onSpendChips(card: Library.PokerFriendsPanel.FriendCard): void {
        // store card of the friend that got chips given
        this._friendCardGotChips = card;

        // open give chips configuration dialog (allows to control how much chips the user want to send)
        this.layoutManager.showDialog("Poker2GiveChipsConfigDialog", new Poker2GiveChipsConfigDialogProperties(card.buddyData.playerId, 1000, card.buddyData.playerName));
    }

    /**
     * Disables the give chips btn for the friend that has got chips.
     */
    protected onChipsSent(event: Event): void {
        if (this._friendCardGotChips) {
            this._friendCardGotChips.mc_cardinfo.btn_chips.enableButton = false;
            this._friendCardGotChips.mc_cardinfo.btn_chips.toolTipText = Poker2Model.languageData.getTextById("dialog_profilcard_sendChips_inactiveTooltip");

            // store informatin that the btn has to be disabled
            this._friendCardGotChips.mc_cardinfo.btn_chips.friendAlreadyGotChips = true;
            this._friendCardGotChips.mc_cardinfo.friendAlreadyGotChips = true;
        }
    }

    private fillBuddyItem(cItem: Library.PokerFriendsPanel.FriendCard, buddyData: BuddyVO, redrawThumb: boolean = true): void {
        cItem.btn_addfriend.visible = false;
        cItem.mc_cardinfo.visible = true;
        cItem.mc_cardinfo.txt_level.text = String(Balancing.calcLevelFromXP(buddyData.playerXp));
        cItem.mc_cardinfo.txt_level.mouseEnabled = false;
        cItem.mc_cardinfo.txt_name.mouseEnabled = false;
        cItem.mc_cardinfo.txt_chips.mouseEnabled = false;
        TextFieldHelper.changeTextFromatSizeByTextWidth(8, cItem.mc_cardinfo.txt_name, buddyData.playerName);
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, cItem.mc_cardinfo.txt_chips, PokerTextHelper.getShortGroupNumberString(buddyData.cashTotal));
        cItem.buddyData = buddyData;

        cItem.mc_cardinfo.mc_holder.mouseChildren = false;
        cItem.mc_cardinfo.mc_holder.mouseEnabled = false;

        if (buddyData.thumbUrl && buddyData.thumbUrl != "" && buddyData.thumbUrl.search(Poker2FriendsPanel.NOPIC_PATTERN) == -1) {
            if (redrawThumb) {
                var loader: Loader = new Loader();
                var request: URLRequest = new URLRequest(buddyData.thumbUrl);
                loader.load(request);
                loader.contentLoaderInfo.addEventListener(Event.COMPLETE, this.bindFunction(this.onPicLoadComplete));
                loader.contentLoaderInfo.addEventListener(IOErrorEvent.IO_ERROR, this.bindFunction(this.onPicLoadError));
                loader.contentLoaderInfo.addEventListener(SecurityErrorEvent.SECURITY_ERROR, this.bindFunction(this.onPicLoadError));

                while (cItem.mc_cardinfo.mc_holder.numChildren > 0)
                    cItem.mc_cardinfo.mc_holder.removeChildAt(0);
                cItem.mc_cardinfo.mc_holder.addChild(loader);
            }
        }
        else {
            var buddyMC: Container = AvatarHelper.drawAvatarByItemArray(Poker2Model.avatarData.getAvatarClothesArray(buddyData.avatarVO));
            var bounds: Rectangle = buddyMC.getBounds(null);
            buddyMC.x = -((bounds.width * Poker2FriendsPanel.AVATAR_SCALE_FACTOR) / 2 + (bounds.left * Poker2FriendsPanel.AVATAR_SCALE_FACTOR));
            buddyMC.y = -(bounds.top * Poker2FriendsPanel.AVATAR_SCALE_FACTOR + 5);
            buddyMC.scaleX = buddyMC.scaleY = Poker2FriendsPanel.AVATAR_SCALE_FACTOR;

            while (cItem.mc_cardinfo.mc_holder.numChildren > 0)
                cItem.mc_cardinfo.mc_holder.removeChildAt(0);
            cItem.mc_cardinfo.mc_holder.addChild(buddyMC);
            cItem.mc_cardinfo.mc_holder.doCache(0, Poker2LayoutManager.GAME_SCALE_FACTOR);
        }

        cItem.mc_cardinfo.mc_onlineIcon.gotoAndStop(buddyData.isOnline ? 1 : 3);

        cItem.mc_cardinfo.btn_statistic.toolTipText = Poker2Model.languageData.getTextById("dialog_profilecard_statistic");
        cItem.mc_cardinfo.btn_chips.toolTipText = Poker2Model.languageData.getTextById("dialog_profilecard_sendChips");

        // friendAlreadyGotChips is stored as an dynamcic property in the btn_chips mc
        if (cItem.mc_cardinfo.friendAlreadyGotChips) {
            if (cItem.mc_cardinfo.friendAlreadyGotChips) {
                cItem.mc_cardinfo.btn_chips.enableButton = false;
                cItem.mc_cardinfo.btn_chips.toolTipText = Poker2Model.languageData.getTextById("dialog_profilcard_sendChips_inactiveTooltip");
            }
            else {
                cItem.mc_cardinfo.btn_chips.enableButton = true;
            }
        }
        else {
            cItem.mc_cardinfo.btn_chips.enableButton = buddyData.avatarVO.allowGiveChips;
        }

        cItem.mc_cardinfo.btn_remove.toolTipText = Poker2Model.languageData.getTextById("dialog_profilecard_removeBuddy");
        cItem.mc_cardinfo.btn_remove.enableButton = !buddyData.isSocialFriend;
        cItem.mc_cardinfo.btn_join.toolTipText = Poker2Model.languageData.getTextById("dialog_profilecard_join");
        cItem.mc_cardinfo.btn_join.enableButton = buddyData.isOnline;
    }

    private fillItems(): void {
        this.initArrows();
        this.ownCardIndex = -1;

        for (var i: number = this.currentCard; i < this.currentCard + this.ITEMS_PER_PAGE; i++) {
            var currentItem: number = i - this.currentCard;
            var cItem: Library.PokerFriendsPanel.FriendCard = this.friendsPanel["friendCard" + currentItem] as Library.PokerFriendsPanel.FriendCard;
            cItem.uncache();
            cItem.mc_cardinfo.y = Poker2FriendsPanel.CARD_INFO_START_Y;
            cItem.mc_cardinfo.isOpening = false;
            cItem.mc_cardinfo.isClosing = false;
            cItem.mc_cardinfo.transitionState = "init";

            //cItem.mc_cardinfo.mouseChildren = false;
            if (i < this.friendList.length) {
                var buddyData: BuddyVO = this.friendList[i];

                if (buddyData.playerId == Poker2Model.userData.playerID)
                    this.ownCardIndex = currentItem;

                this.fillBuddyItem(cItem, buddyData);
                cItem.visible = true;
            }
            else {
                cItem.buddyData = null;
                TextFieldHelper.changeTextFromatSizeByTextWidth(9, cItem.btn_addfriend.txt_label, Poker2Model.languageData.getTextById("buddylist_addfriend"), 2);
                //					cItem.btn_addfriend.enableButton = !Poker2Model.userData.isGuest();
                cItem.btn_addfriend.visible = true;
                cItem.visible = this.env.invitefriends;
                cItem.mc_cardinfo.visible = false;
            }
        }
    }

    private onChangeOnlineState(event: Poker2BuddyEvent = null): void {
        for (var i: number = this.currentCard; i < this.currentCard + this.ITEMS_PER_PAGE; i++) {
            var curentItem: number = i - this.currentCard;
            var cItem: Library.PokerFriendsPanel.FriendCard = this.friendsPanel["friendCard" + curentItem] as Library.PokerFriendsPanel.FriendCard;
            cItem.uncache();
            if (i < this.friendList.length) {
                var buddyData: BuddyVO = this.friendList[i];
                cItem.buddyData = buddyData;
                cItem.mc_cardinfo.mc_onlineIcon.gotoAndStop(buddyData.isOnline ? 1 : 3);
                cItem.mc_cardinfo.btn_join.enableButton = buddyData.isOnline;
            }
        }
    }

    protected onPicLoadError(e: Event): void {
        var errorMsg: string;

        switch (getQualifiedClassName(e)) {
            case "flash.events::IOErrorEvent":
                errorMsg = e.type + ": " + (e as IOErrorEvent).text;
                break;
            case "flash.events::SecurityErrorEvent":
                errorMsg = e.type + ": " + (e as SecurityErrorEvent).text;
                break;
            default:
                errorMsg = e.type;
                break;
        }
        console.log(errorMsg);
        //throw new Error("Fehler beim Streamen der BuddylistPictures! \n\n" + e.text);;
    }

    private onPicLoadComplete(event: Event): void {
        event.target.removeEventListener(Event.COMPLETE, this.bindFunction(this.onPicLoadComplete));
        var gfx: Loader = event.target.loader;
        var bounds: Rectangle = gfx.getBounds(null);

        var userPicScale: number = this.CITEM_HEIGHT / bounds.height;
        gfx.scaleX = gfx.scaleY = userPicScale;
        gfx.y = 0;
        gfx.x = -bounds.width * userPicScale / 2;
    }

    private initArrows(): void {
        this.friendsPanel.btn_right_card.enableButton = this.currentCard > 0;
        this.friendsPanel.btn_right_line.enableButton = this.currentCard > 0;
        this.friendsPanel.btn_right_end.enableButton = this.currentCard > 0;
        this.friendsPanel.btn_left_card.enableButton = (this.currentCard + this.ITEMS_PER_PAGE) < this.friendList.length;
        this.friendsPanel.btn_left_line.enableButton = (this.currentCard + this.ITEMS_PER_PAGE) < this.friendList.length;
        this.friendsPanel.btn_left_end.enableButton = (this.currentCard + this.ITEMS_PER_PAGE) < this.friendList.length;
    }

    protected get friendsPanel(): Library.PokerFriendsPanel.FriendsPanel {
        return this.disp as Library.PokerFriendsPanel.FriendsPanel;
    }

    public static __initialize_static_members() {
        Poker2FriendsPanel.NOPIC_PATTERN = new RegExp("nopic", "i");
        Poker2FriendsPanel.CARD_INFO_END_Y = int(-86.5);
    }
}
import { BIGCommand } from "../../controller/commands/buddy/BIGCommand";
import { Poker2GiveChipsConfigDialog } from "../dialogs/giveChipsConfig/Poker2GiveChipsConfigDialog";
import { Poker2GuestInviteFriendDialog } from "../dialogs/Poker2GuestInviteFriendDialog";
import { Poker2InviteFriendDialog } from "../dialogs/Poker2InviteFriendDialog";
import { Poker2StandardYesNoDialog } from "../dialogs/Poker2StandardYesNoDialog";
import { AvatarHelper } from "../helper/AvatarHelper";

Poker2FriendsPanel.__initialize_static_members();

import { instanceOfClass } from "@goodgamestudios/createjs-utilities";
import { BasicButton } from "@goodgamestudios/poker2-createjs-assets";
import {Poker2LayoutManager} from "../Poker2LayoutManager";
